import {
  ISO_IMPLEMENTATION_META,
  standardGuideLabel,
  type IsoImplementationStandard,
} from './isoImplementationConstants';

interface IsoImplementationUnavailableProps {
  standard: IsoImplementationStandard;
  guideSlug: string;
  title: string;
  detail?: string | null;
}

export function IsoImplementationUnavailable({
  standard,
  guideSlug,
  title,
  detail,
}: IsoImplementationUnavailableProps) {
  const meta = ISO_IMPLEMENTATION_META[standard];
  const guideLabel = standardGuideLabel(standard, guideSlug);

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-6">
      <div className="rounded-lg border border-destructive/30 bg-card p-5">
        <p className="text-sm font-semibold text-destructive">{title}</p>
        <p className="mt-2 text-sm text-muted-foreground">
          No se encontró el catálogo de implementación para {meta.label} · {guideLabel}.
          Estas pantallas se alimentan desde guías semilla cargadas en la base de datos.
        </p>
        {detail ? <p className="mt-2 text-sm text-muted-foreground">Detalle: {detail}</p> : null}
      </div>

      <div className="rounded-lg border border-border bg-muted/30 p-5 text-sm text-muted-foreground">
        <p className="font-medium text-foreground">Cómo se carga</p>
        <p className="mt-2">
          En local o QA, el catálogo se carga de forma idempotente con el seed ISO:
        </p>
        <code className="mt-3 block rounded bg-background px-3 py-2 text-xs text-foreground">
          cd apps/backend &amp;&amp; npm run seed:iso-implementation
        </code>
        <p className="mt-3">
          El seed toma los archivos de catálogo versionados del backend y crea las guías,
          fases, tareas y entregables requeridos.
        </p>
      </div>
    </div>
  );
}
